import { useState, useEffect } from "react";
import { Program } from "../types/program";
import apiClient from "../services/api";

/**
 * Fetches multiple programs by slug in parallel.
 * Returns an array of Program objects (in the same order as the slugs).
 */
const useFetchPrograms = (slugs: string[]) => {
  const [programs, setPrograms] = useState<Program[]>([]);
  const [loading, setLoading] = useState(true);

  const slugKey = slugs.join(",");

  useEffect(() => {
    if (!slugs.length) {
      setLoading(false);
      return;
    }

    const fetchPrograms = async () => {
      try {
        setLoading(true);
        const responses = await Promise.all(
          slugs.map((slug) => apiClient.getProgram(slug))
        );

        const fetched: Program[] = [];
        responses.forEach((response) => {
          if (response.success) {
            const data = response?.data ?? response;
            const programData = data?.program ?? data;
            if (programData && (programData.id || programData.slug || programData.title)) {
              fetched.push(programData as Program);
            }
          }
        });
        setPrograms(fetched);
      } catch (err) {
        console.error("Error fetching programs:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPrograms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugKey]);

  return { programs, loading };
};

export default useFetchPrograms;
